module.exports = __webpack_public_path__ + "static/img/faq_about04.01417d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/faq_about04.png
// module id = 4h6b
// module chunks = 2